import { render, staticRenderFns } from "./groupFitnessDashboardRooms.vue?vue&type=template&id=2b6f875a&scoped=true"
import script from "./groupFitnessDashboardRooms.vue?vue&type=script&lang=js"
export * from "./groupFitnessDashboardRooms.vue?vue&type=script&lang=js"
import style0 from "./groupFitnessDashboardRooms.vue?vue&type=style&index=0&id=2b6f875a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6f875a",
  null
  
)

export default component.exports